import * as React from 'react';
import GearOutlined from './gear-outlined';
import GearFilled from './gear-filled';
import type { IconCombinedProps } from './types';
const GearCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <GearFilled ref={ref} {...rest} />;
  }
  return <GearOutlined ref={ref} {...rest} />;
});
export default GearCombined;